<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ myTicketSafe.itemLabel }}</div>
    </header>
    <div>
      <!-- <canvas id="myticket-qrcode"></canvas> -->
      <div class="qrcode-container">
        <img v-bind:src="imageBytes" id="myticket-qrcode" alt="qrcode" />
        <!-- <div v-if="validated"><i class="fa fa-fw fa-check"></i></div> -->
      </div>
      <p>{{myTicketSafe.itemProductLabel}}</p>
      <p>{{myTicketSafe.itemDescriptions}}</p>
      <p>{{ 'Price' | lang }}: {{myTicketSafe.amount / 100 | currency}}</p>
      <p>{{ 'AvailableTickets' | lang }}: {{myTicketSafe.details.ETicketSold}}</p>
      <div style="text-align: center;"><img src="/img/qrcode.gif"   style="max-width: 250px;" /></div> 
    </div>

    <footer>
      <button v-if="!validated" @click="setAsValidated" :disabled="validating">{{ 'markAsValidated' | lang }}</button>
      <button v-else-if="!myTicketSafe.vadValidated" @click="setAsNotValidated" class="green" :disabled="validating">{{ 'validated' | lang }} <i class="fa fa-fw fa-check"></i></button>
      <button v-else disabled class="green">{{ 'validated' | lang }} <i class="fa fa-fw fa-check"></i></button>
      <!--<button @click="addToCart(false)">Aggiungi</button>
      <button @click="addToCart(true)">Aggiungi e chiudi</button>-->
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
// import QRCode from 'qrcode'
// import CountSelector from '@/components/CountSelector'
// import AdvancedSelect from '@/components/AdvancedSelect'
import eticketServices from '@/mixins/services/eticketsServices'

export default {
  name: 'MyTicket',
  mixins: [ page, databaseWrapperMixin, eticketServices ],
  // components: { CountSelector, AdvancedSelect },
  props: ['myTicketId'],
  data () {
    return {
      validating: false
    }
  },
  computed: {
    myTicket () {
      return this.dwMyTickets.find(t => t.id === this.myTicketId)
    },
    myTicketSafe () {
      return this.myTicket || { ticketInfo: {} }
    },
    validated () {
      return this.myTicketSafe.vadValidated || this.myTicketSafe.userValidated
    },
    imageBytes () {
      return 'data:image/*;base64,'+ this.myTicketSafe.qrcode
    }
  },
  methods: {
    setAsValidated () {
      this.validating = true
      this.dwSetTicketUserValidated(this.myTicketId, true)
      if (this.isConnected) {
        this._userValidateEticket(this.myTicketId, true).then(() => {
          this.validating = false
          this.checkValidation()
        }).catch(err => {
          console.warn(err)
          // this.dwSetTicketUserValidated(this.myTicketId, false)
          this.dwAddPendingUserValidation(this.myTicketId, true)
          this.validating = false
        })
      } else {
        this.validating = false
        this.dwAddPendingUserValidation(this.myTicketId, true)
      }
    },
    setAsNotValidated () {
      this.validating = true
      this.dwSetTicketUserValidated(this.myTicketId, false)
      // this.dwAddPendingUserValidation(this.myTicketId, false)
      if (this.myTicketSafe.userCode) {
        this._userValidateEticket(this.myTicketId, false).then(() => {
          this.validating = false
          this.checkValidation()
        }).catch(err => {
          console.warn(err)
          // this.dwSetTicketUserValidated(this.myTicketId, true)
          this.dwAddPendingUserValidation(this.myTicketId, false)
          this.validating = false
        })
      } else {
        this.validating = false
      }
    },
    /* drawQR () {
      this.$nextTick(() => {
        if (this.myTicket) {
          let canvas = this.$el.querySelector('#myticket-qrcode')
          QRCode.toCanvas(canvas, '' + this.myTicket.id, { width: canvas.width })
            .then(e => {
              console.log('generated', e)
            }).catch(e => {
              console.error(e)
            })
        }
      })
    } */
    checkValidation () {
      /* this._updateValidations([this.myTicketId]).then(resp => {
        resp.forEach(r => {
          this.dwSetTicketVadValidated(r.EticketId, r.Validated)
          if (r.EticketId === this.myTicketId) {
            clearInterval(this.valInterval)
          }
        })
      }) */
      this.internalBus.$emit('updateEticketVadValidations', [this.myTicketId])
    }
  },
  beforeDestroy () {
    clearInterval(this.valInterval)
  },
  mounted () {
    // this.drawQR()
    this.valInterval = setInterval(this.checkValidation, 30000)
    this.checkValidation()
  },
  watch: {
    /* myTicket () {
      this.drawQR()
    } */
    'myTicketSafe.vadValidated' (newV) {
      if (newV) {
        clearInterval(this.valInterval)
      }
    }
  }
}
</script>

<style lang="scss">

#myticket-qrcode {
  width: 100%;
  margin: 0 auto;
}

.qrcode-container {
  position: relative;
  overflow: hidden;
  flex: 1 0 auto !important;

  div {
    position: absolute;
    top: 0;
    right: 0;
    width: 10rem;
    height: 10rem;
    transform: rotate(20deg);
    color: var(--white);
    font-size: 8rem;
    background: var(--green);
    border-radius: 50%;
  }
}

</style>
